import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Config from "../api/config";
import Http from "../layout/Http";

// Shop info + review_type of the login QR code ("product" | "store" | "both").
// notFound: shop off, plan without QR codes, or the login QR is disabled.
const useShopProfile = () => {
    const { shop_id } = useParams();
    const [shop, setShop] = useState({});
    const [reviewType, setReviewType] = useState("product");
    // Star icon + corner settings (null = built-in defaults)
    const [globalDisplay, setGlobalDisplay] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        let cancelled = false;
        Http.get(`${Config.BASE_URL}/customer-management/guest/${shop_id}/shop`)
            .then((res) => {
                if (cancelled) return;
                if (res.data?.status && res.data?.shop) {
                    setShop(res.data.shop);
                    setReviewType(res.data.review_type || "product");
                    setGlobalDisplay(res.data.global_display || null);
                } else {
                    setNotFound(true);
                }
            })
            .catch((err) => {
                console.error("Error fetching shop info:", err);
                if (!cancelled) setNotFound(true);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [shop_id]);

    return { shop, reviewType, globalDisplay, loading, notFound };
};

export default useShopProfile;
